// extracted by mini-css-extract-plugin
export default {"icon":"icon-VKRw","avatar":"avatar-jpIv","avatarDefault":"avatarDefault-ov7V","number":"number-F0fc","text":"text-o8n1"};